export enum AppointmentKinds {
   CANCEL = "Cancel",
   RESCHEDULED = "Rescheduled",
   NOT_ELIGIBLE = "NotEligible",
   REQUESTED = "Requested",
   CONFIRMED = "Confirmed",
}
